import { render, staticRenderFns } from "./KnowledgeUnitPreviewView.vue?vue&type=template&id=1330e6a4&"
import script from "./KnowledgeUnitPreviewView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitPreviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports